import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateDivisioneForm } from '../Validations/ValidationsDivisione';

export default function EditDivisioneForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ id: '', descripcion: '', lugareId: '' });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDivisione = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/divisiones/${id}`);
        setFormData({
          id: response.data.id || '',
          descripcion: response.data.descripcion || '',
          lugareId: response.data.lugareId || ''
        });
      } catch (err) {
        setError('Error al cargar los datos del sector.');
      } finally {
        setIsLoading(false);
      }
    };

    if (id) fetchDivisione();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateDivisioneForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      setError(null);
      try {
        await axios.put(`/divisiones/${id}`, formData);
        navigate('/home/divisiones');
      } catch (err) {
        setError('Error al actualizar el sector. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-10 bg-blue-100 p-8 rounded-lg shadow-lg border border-blue-300">
      <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">Editar Sector</h2>
      {isLoading && <div className="text-center text-blue-600">Cargando...</div>}
      {error && <div className="text-center text-red-500">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-blue-700 font-medium">ID</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            className="w-full p-3 border rounded-lg bg-gray-200 text-gray-700 cursor-not-allowed"
            readOnly
          />
        </div>
        <div>
          <label className="block text-blue-700 font-medium">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.descripcion ? 'border-red-500' : 'border-blue-300'}`}
            required
          />
          {errors.descripcion && <p className="text-red-500 text-sm mt-1">{errors.descripcion}</p>}
        </div>
        <div>
          <label className="block text-blue-700 font-medium">ID del Sector</label>
          <input
            type="text"
            name="lugareId"
            value={formData.lugareId}
            onChange={handleChange}
            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.lugareId ? 'border-red-500' : 'border-blue-300'}`}
            required
          />
          {errors.lugareId && <p className="text-red-500 text-sm mt-1">{errors.lugareId}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition-all"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar Sector'}
        </button>
      </form>
    </div>
  );
}
